(function() {
  var wid = $WR.define('cheetahApplication/form/savebutton', [], function(require, exports, module) {
    var HTML = '';
    module.exports = require('form/default/Button');
  });
  $WR.defineType({
    id: wid,
    xtype: 'saveButton',
    designer: 'DesignerSaveButton'
  });
})();


(function() {
    var wid = $WR.define('cheetahApplication/form/DesignerSaveButton', [], function(require, exports, module) {
      var HTML = '';
      var Class = MW.extend(require('designer/form/default/Button'), {
        defaults: {
          xtype: 'saveButton',
          xtypeName: '保存按钮',
          value: "保存",
          actionName: "保存",
          action: "formSave",
          sizeCls: "btn-std",
          iconCls: "fa fa-save",
          colorCls: "btn-primary"
        }
      });
      module.exports = Class;
    });
    $WR.defineType({
      id: wid,
      xtype: 'DesignerSaveButton',
      designer: ''
    });
})();




// WEBPACK FOOTER //
// ./src/common/formWidget/saveButton.js